import { Pipe, PipeTransform } from '@angular/core';
/*
 * Receives complaint reason string in english
 * and returns the value in spanish
*/

@Pipe({
  name: 'complaintReasons'
})
export class ComplaintReasonsPipe implements PipeTransform {

  transform(value: string, args?: string[]): any {
    if (!value) return value;
    switch (value) {
        case 'DAMAGE':
            return 'Dañado';
        case 'MISSED':
            return 'No llegó';
        case 'INCOMPLETE':
            return 'Incompleto';
        case 'LATE':
            return 'Tarde';
        default:
            return value;
    }
  }

}


// WEBPACK FOOTER //
// /codebuild/output/src4156872633/src/src/app/pipes/complaint-reasons.pipe.ts